import { getNewsByPage } from "@/service";

export default {
    namespaced: true,
    state: {
        newsList: [], // 所有
    },
    mutations: {
        setNewList(state, payload) {
            state.newsList = payload;
        }
    },
    actions: {
        getNewsList({ commit }) {
            return new Promise(async (resolve, reject) => {
                let res = await getNewsByPage({limit:100});
                if (res.code == '12200') {
                    commit("setNewList", res.data.list)
                    resolve(res.data.list)
                }
            })
        }
    }
}
